import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3345857214/src/src/app/ui/common/side-menu.tsx");
